import { render } from "./Variety_good_things.vue?vue&type=template&id=203437fc&scoped=true"
import script from "./Variety_good_things.vue?vue&type=script&lang=js"
export * from "./Variety_good_things.vue?vue&type=script&lang=js"

import "./Variety_good_things.vue?vue&type=style&index=0&id=203437fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203437fc"]])

export default __exports__